var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVilomix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 243.85 115.29",
    style: {
      enableBackground: "new 0 0 243.85 115.29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#255088;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.7,78.99c0.24,2.16,0.42,4.44,0.48,7.2h0.12c0.96-2.52,1.56-4.08,3.36-7.8l9.66-19.68h11.46L22.2,99.21 H9.36L5.04,66.99c-1.38-0.24-3.3-0.48-5.04-0.6l1.32-7.14c4.38-0.48,9.12-0.66,14.1-0.54L17.7,78.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.04,99.21H39.3l4.14-21.48v-0.12c-1.38-0.24-3.3-0.48-5.04-0.6l1.32-7.14c4.98-0.54,10.32-0.72,16.02-0.54 L50.04,99.21z M51.54,67.11c-3.66,0-6.12-2.82-6.12-5.88c0-3.9,3.36-6.72,6.96-6.72c3.6,0,6.12,2.82,6.12,5.76 C58.5,64.29,55.14,67.11,51.54,67.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.66,99.21H58.92l6.78-35.58c-1.38-0.24-3.3-0.48-5.04-0.6l1.32-7.14c4.98-0.54,10.32-0.72,16.02-0.54 L69.66,99.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.34,99.93c-9.54,0-12.66-4.26-12.66-10.86c0-13.32,9.54-20.4,18.9-20.4c9.42,0,12.54,4.74,12.54,11.1 C108.12,91.95,99.18,99.93,89.34,99.93z M93.9,78.15c-4.14,0-6,5.64-6,9.3c0,1.56,0.6,2.94,2.7,2.94c4.5,0,6.24-5.46,6.24-9.18 C96.84,79.17,96.12,78.15,93.9,78.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.7,99.21h-10.74l3.48-18.18c0.42-2.22,0.18-2.94-0.6-2.94c-1.86,0-6.18,6-7.38,12.24l-1.68,8.88H128.1 l3.48-18.18c0.42-2.22,0.18-2.94-0.6-2.94c-1.86,0-6.18,6-7.38,12.24l-1.68,8.88h-10.74l4.08-21.36l0.06-0.24 c-1.38-0.24-3.36-0.48-5.04-0.6l1.32-7.14c4.98-0.54,10.38-0.72,15.42-0.54c-0.3,1.62-0.9,3.72-1.8,5.7h0.12 c2.7-3.84,5.82-6.42,10.68-6.42c3.36,0,6.18,1.74,6.18,5.88c0,0.18,0,0.48-0.06,0.9h0.06c2.76-4.26,6-6.78,10.86-6.78 c6.12,0,7.68,4.38,6.66,9.66L155.7,99.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.78,99.21h-10.74l4.14-21.48v-0.12c-1.38-0.24-3.3-0.48-5.04-0.6l1.32-7.14 c4.98-0.54,10.32-0.72,16.02-0.54L174.78,99.21z M176.28,67.11c-3.66,0-6.12-2.82-6.12-5.88c0-3.9,3.36-6.72,6.96-6.72 c3.6,0,6.12,2.82,6.12,5.76C183.24,64.29,179.88,67.11,176.28,67.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204.48,84.99l6.06,14.22h-12.42l-2.28-7.8l-7.68,9.96l-9.3-4.92l11.82-13.14l-5.94-13.92h11.82l2.52,7.86 l7.62-10.02l9,4.86L204.48,84.99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222.8,28.46c17.33-7.39,19.9-18.34,21.06-22.79c-2.89,3.98-9.35,6.39-13.5,7.39 c-3.78,0.92-11.1,1.93-18.09,5.3c-6.95,3.35-9.73,9.03-11.77,13.37c-2.24,4.77-3.49,12.29-3.49,12.29 C205.1,34.64,210.41,33.75,222.8,28.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.9,36.19c-17.33,7.39-19.9,18.34-21.06,22.8c2.9-3.99,9.35-6.39,13.5-7.4c3.78-0.92,11.1-1.93,18.09-5.3 c6.95-3.34,9.73-9.03,11.77-13.37c2.24-4.77,3.49-12.3,3.49-12.3C232.59,30,227.29,30.9,214.9,36.19z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVilomix);
export default __webpack_public_path__ + "static/media/Vilomix.98adeab021fadf91f0061943326058d2.svg";
export { ForwardRef as ReactComponent };